export enum PermissionPropertiesEnum {
  optionalOn = 'optional_on',
  optionalOff = 'optional_off',
  on = 'on',
  off = 'off'
}